import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbDocumentos extends AppService {
  abstract getAllDocumentos(filter: AppFilter): Observable<any>;
  abstract salvarDocumento(entity);
  abstract getDocumento(id);
  abstract deleteDocumento(id);
  abstract getCategoria(id);
  abstract salvarCategoria(entity);
  abstract salvarSubcategoria(entity);
  abstract deleteSubcategoria(id);
  abstract deleteCategoria(id);
  abstract getAllCategorias(): Observable<any>;
  abstract getAllCategoriasFilter(filter: AppFilter): Observable<any>;
  abstract uploadAnexos(documentoId: number, arquivos): Observable<any>;
  abstract getUsoArmazenamento(): Observable<any>;
}